import Logger from '../../common/Logger';

export function telemetryClickHandler(
  clickEventName?: string
): (() => void) | undefined {
  return clickEventName
    ? () => Logger.accessTelemetry().increment(clickEventName)
    : undefined;
}

export function telemetryImpressionHandler(impressionEventName?: string): void {
  if (impressionEventName) {
    Logger.accessTelemetry().increment(impressionEventName);
  }
}
